site.k6 = {
	init: function() {
		site.k6.openingHours();
		site.k6.footer();
	},

	openingHours: function () {
		site.maxHeight.init('#openingHoursDetails');
		site.toggle.init('#openingHoursToggle', '#openingHoursDetails', 'openingHours');
	},

	footer: function () {

		$('.box_tiny', 'footer')
			.append('<div class="expandRight"><button class="expandBtnRight" aria-hidden="true"></div>')
			.prepend('<div class="expandLeft"><button class="expandBtnLeft" aria-hidden="true"></div>');

		$('.expandBtnLeft').on('click', function () {
			setTimeout(function(){ moya.map.osmMap.invalidateSize()}, 100);
			$('.expandLeft').toggleClass('open');
		});
		$('.expandBtnRight').on('click', function () {
			setTimeout(function(){ moya.map.osmMap.invalidateSize()}, 100);
			$('.expandRight').toggleClass('open');
		});

		$('.box_moyaMap', 'footer')
			.append('<div class="expand">' +
				'<button class="expandBtnMap" aria-hidden="true">' +
				'<button class="expandBtnPic" aria-hidden="true"></div>');

		$('.expandBtnPic').on('click', function () {
			setTimeout(function(){ moya.map.osmMap.invalidateSize()}, 100);
			var $openMap = $('.box_moyaMap', 'footer').hasClass('open');
			var $openPic = $('.box_moyaMap', 'footer').hasClass('closed');
			if (!$openMap && $openPic){
				$('.box_moyaMap', 'footer').addClass('open');
				$('.box_moyaMap', 'footer').removeClass('closed');
			}
			else if ($openPic) {
				$('.box_moyaMap', 'footer').addClass('open');
			}
			else if (!$openMap && !$openPic) {
				$('.box_moyaMap', 'footer').addClass('open');
			}
			else {
				$('.box_moyaMap', 'footer').removeClass('open');
			}

		} );

		$('.expandBtnMap').on('click', function () {
			var $openMap = $('.box_moyaMap', 'footer').hasClass('open');
			var $openPic = $('.box_moyaMap', 'footer').hasClass('closed');
			if (!$openPic && $openMap){
				$('.box_moyaMap', 'footer').addClass('closed');
				$('.box_moyaMap', 'footer').removeClass('open');
			}
			else if ($openMap) {
				$('.box_moyaMap', 'footer').addClass('closed');
			}
			else if (!$openMap && !$openPic) {
				$('.box_moyaMap', 'footer').addClass('closed');
			}
			else {
				$('.box_moyaMap', 'footer').removeClass('closed');
			}

		} )

	}
};

site.inits.push('site.k6.init()');